import Event from '../../core/Event';
import { OrderStocks } from '../../../domain/Order';
import Product from '../../../domain/Product';

export default class OrderChangeRequested extends Event {
    public static type = 'OrderChangeRequested';

    constructor(
        public readonly product: Product,
        public readonly value: number,
        public readonly sku: string,
        public readonly variantCode: string,
        public readonly field: keyof OrderStocks,
        public readonly validate?: boolean,
        public readonly liabilityToSet?: number
    ) {
        super(OrderChangeRequested.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/order/events/OrderChangeRequested.ts